import { render, staticRenderFns } from "./GroundShipping.vue?vue&type=template&id=168db70f"
import script from "./GroundShipping.vue?vue&type=script&lang=js"
export * from "./GroundShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports